// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!./vertical-overlay-menu.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("423d18d5", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/vertical-overlay-menu.css
// module id = 923
// module chunks = 0